// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports

// Bootstrap Imports
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'

export default function ToolbarExpirationDate({ size = 'sm' }) {
   const state = useQuoteContext()
   const { getString } = state
   if (state.user_role != 'Partner' && state.user_role != 'Reseller') {
      return (
         <InputGroup size={size}>
            <InputGroup.Text id='expirationdateAddon' size={size}>
               {getString('product.ToolbarExpirationDate.InputText')}
            </InputGroup.Text>
            <Form.Control
               type='date'
               size={size}
               value={state.quoteExpirationDate}
               onChange={state.onExpirationChange}
            ></Form.Control>
         </InputGroup>
      )
   } else {
      return null
   }
}
